"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var LoadingButton_1 = __importDefault(require("@mui/lab/LoadingButton"));
var Send_1 = __importDefault(require("@mui/icons-material/Send"));
var Step_1 = __importDefault(require("../Step/Step"));
function Stepper(_a) {
    var _this = this;
    var _b;
    var validateStep = _a.validateStep, steps = _a.steps, disabled = _a.disabled, currentStep = _a.currentStep, type = _a.type, customValidateLabel = _a.customValidateLabel, maxSteps = _a.maxSteps, forgetMode = _a.forgetMode;
    var _c = __read((0, react_1.useState)(currentStep || 0), 2), selectedStep = _c[0], setSelectedStep = _c[1];
    var _d = __read((0, react_1.useState)(new Array(steps.length).fill(false)), 2), visited = _d[0], setVisited = _d[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var selectElt = function (key) {
        if (forgetMode) {
            setVisited(visited.map(function (_v, index) { return index <= key; }));
        }
        else {
            var visitedTmp = __spreadArray([], __read(visited), false);
            visitedTmp[selectedStep] = true;
            setVisited(visitedTmp);
        }
        setSelectedStep(key);
    };
    var goToNextElt = function (key) { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateStep === undefined;
                    if (_a) return [3 /*break*/, 3];
                    _b = validateStep !== undefined;
                    if (!_b) return [3 /*break*/, 2];
                    return [4 /*yield*/, validateStep(selectedStep)];
                case 1:
                    _b = (_c.sent());
                    _c.label = 2;
                case 2:
                    _a = (_b);
                    _c.label = 3;
                case 3:
                    if (_a) {
                        if (key != null) {
                            selectElt(key);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        setSelectedStep(currentStep || 0);
    }, [steps, currentStep]);
    var getIndexFromKey = function (key) {
        var index = Object.values(steps).findIndex(function (step) { return step.key === key; });
        return index > -1 ? index : 0;
    };
    return ((0, jsx_runtime_1.jsxs)(system_1.Stack, { children: [(0, jsx_runtime_1.jsx)(system_1.Stack, __assign({ spacing: 2, direction: "row", alignItems: "flex-end" }, { children: Object.values(steps).map(function (step, index) {
                    var displayStep = false;
                    var indexSelected = getIndexFromKey(selectedStep);
                    if (maxSteps) {
                        displayStep =
                            (index >= indexSelected && index < indexSelected + maxSteps) ||
                                (indexSelected >= Object.values(steps).length - maxSteps &&
                                    index >= Object.values(steps).length - maxSteps);
                    }
                    else {
                        displayStep = true;
                    }
                    if (displayStep) {
                        return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { flex: 1 } }, { children: (0, jsx_runtime_1.jsx)(Step_1.default, { label: step.value, id: step.key, selected: selectedStep === step.key, visited: visited[index] }) }), step.key));
                    }
                    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                            bgcolor: index > indexSelected && !visited[index]
                                ? 'secondary.light'
                                : 'primary.main',
                            borderRadius: 8,
                            height: 8,
                            width: '15px',
                        } }));
                }) })), (0, jsx_runtime_1.jsx)(system_1.Stack, __assign({ marginTop: 6 }, { children: (_b = steps[selectedStep]) === null || _b === void 0 ? void 0 : _b.content })), (0, jsx_runtime_1.jsxs)(system_1.Stack, __assign({ spacing: 3, marginTop: 4 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Divider, {}), (0, jsx_runtime_1.jsxs)(system_1.Stack, __assign({ direction: "row", justifyContent: selectedStep === 0 ? 'end' : 'space-between' }, { children: [selectedStep !== 0 && steps.length > 0 && ((0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "outlined", color: "darkGrey", disabled: disabled, onClick: function () {
                                    selectElt(selectedStep - 1);
                                } }, { children: t('ds.previous') }))), selectedStep !== steps.length - 1 && ((0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "contained", disabled: disabled, onClick: function () {
                                    void (function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, goToNextElt(selectedStep + 1)];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); })();
                                } }, { children: t('ds.next') }))), selectedStep === steps.length - 1 && ((0, jsx_runtime_1.jsx)(LoadingButton_1.default, __assign({ type: type, variant: "contained", loading: disabled, loadingPosition: "start", startIcon: (0, jsx_runtime_1.jsx)(Send_1.default, {}), onClick: function () {
                                    void (function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, goToNextElt(undefined)];
                                                case 1:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); })();
                                } }, { children: customValidateLabel || t('ds.validate') })))] }))] }))] }));
}
exports.default = Stepper;
Stepper.defaultProps = {
    validateStep: undefined,
    disabled: false,
    currentStep: 0,
    type: 'button',
    customValidateLabel: undefined,
    maxSteps: undefined,
    forgetMode: false,
};
//# sourceMappingURL=Stepper.js.map